const STYLE_NODE = 'STYLE'
const head = document.querySelector(`head`)
const shellStyleSheet = head?.querySelector('#main-css') ?? null
const observerConfig = {
  attributes: true,
  childList: true,
  characterData: true,
  subtree: true,
}

/**
 * Added a mutation observer to detect when a <style> tag is added the in order to always add shell's style as the last style applied.
 * This is to make sure that the shell's styles are not overwritten by an experience styles
 */
export const keepShellStyleSheetLastInNodeList = () => {
  let appendShellStyleAtTheEnd = false

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (!appendShellStyleAtTheEnd) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeName === STYLE_NODE && !node.isEqualNode(shellStyleSheet)) {
            appendShellStyleAtTheEnd = true
          }
        })
      }
    })

    if (appendShellStyleAtTheEnd && shellStyleSheet) {
      head?.removeChild(shellStyleSheet)
      head?.appendChild(shellStyleSheet)
      appendShellStyleAtTheEnd = false
    }
  })

  if (head) {
    observer.observe(head, observerConfig)
  }
}
